import React, { memo } from "react";
import { Button } from "@mui/material";
import { Alignment, Variant } from "../types";
import clsx from "clsx";
import "./styles.scss";

type Color = "primary" | "secondary";

export interface ButtonComponentProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  id?: string;
  label?: string;
  fullWidth?: boolean;
  color?: Color;
  variant?: Variant;
  roundBorder?: boolean;
  disabled?: boolean;
  customStyles?: string;
  align?: Alignment;
  loading?: boolean;
}

export const BasicButton: React.FC<ButtonComponentProps> = ({
  onClick,
  id,
  label = "Test Button",
  fullWidth = false,
  roundBorder = false,
  disabled = false,
  align = "left",
  variant = "outlined",
  customStyles,
  loading = false,
  ...otherProps
}: ButtonComponentProps) => {
  return (
    <Button
      className={clsx("btn_primary", customStyles)}
      onClick={onClick}
      id={id}
      disabled={disabled}
      fullWidth={fullWidth}
      variant={variant}
      {...otherProps}
    >
      <span className={`${loading && "loading-text"}`}>{label}</span>
    </Button>
  );
};

export default memo(BasicButton);
